import type { BadgeColor } from '@civilgrid/ui/components';

export interface LayerDL {
  layerPickerId?: string;
  value: string;
  title: string;
  type: string;
}

// copied from /packages/client/src/views/Tables/Projects/DatafileDownloadModal.jsx

// NOTE: remove this when the new download page is fully implemented and old download modal is removed
export const layerListFull: LayerDL[] = [
  {
    layerPickerId: 'buildings',
    value: 'Building Footprints',
    title: 'Building Footprints',
    type: 'general',
  },
  {
    layerPickerId: 'contourLines3ft',
    value: 'Contour Lines (full resolution)',
    title: 'Contour Lines (full resolution)',
    type: 'general',
  },
  {
    layerPickerId: 'electricTransmissionStructures',
    value: 'Electric Transmission Structures',
    title: 'Electric Transmission Structures',
    type: 'electric',
  },
  {
    layerPickerId: 'electricTransmissionLines',
    value: 'Electric Transmission Lines',
    title: 'Electric Transmission Lines',
    type: 'electric',
  },
  {
    layerPickerId: 'electricDistributionLines',
    value: 'Electric Distribution Lines',
    title: 'Electric Distribution Lines',
    type: 'electric',
  },
  {
    layerPickerId: 'electricDistributionStructures',
    value: 'Electric Distribution Structures',
    title: 'Electric Distribution Structures',
    type: 'electric',
  },
  {
    layerPickerId: 'electricDistributionServiceLines',
    value: 'Electric Distribution Service Lines',
    title: 'Electric Distribution Service Lines',
    type: 'electric',
  },
  {
    layerPickerId: 'electricDistributionOther',
    value: 'Electric Distribution Other',
    title: 'Electric Distribution Other',
    type: 'electric',
  },
  {
    layerPickerId: 'electricDistributionServiceVaults',
    value: 'Electric Distribution Vaults',
    title: 'Electric Distribution Vaults',
    type: 'electric',
  },
  {
    layerPickerId: 'gasPoints',
    value: 'Gas Points',
    title: 'Gas Points',
    type: 'gas',
  },
  {
    layerPickerId: 'gasDistribution',
    value: 'Gas Distribution',
    title: 'Gas Distribution Main Lines',
    type: 'gas',
  },
  {
    layerPickerId: 'gasTransmission',
    value: 'Gas_Transmission',
    title: 'Gas Transmission',
    type: 'gas',
  },
  {
    layerPickerId: 'gasService',
    value: 'Gas Service',
    title: 'Gas Service',
    type: 'gas',
  },
  {
    // cant find this
    // layerPickerId: 'gasDistributionOther',
    value: 'Groundwater Stations',
    title: 'Groundwater Stations',
    type: 'general',
  },
  {
    layerPickerId: 'landRightsParcels',
    value: 'Parcels',
    title: 'Parcels',
    type: 'general',
  },
  // cant find this
  {
    value: 'Project Outline',
    title: 'Project Outline',
    type: 'general',
  },
  {
    layerPickerId: 'sanitaryPoints',
    value: 'Sanitary Points',
    title: 'Sanitary Points',
    type: 'sanitary',
  },
  {
    layerPickerId: 'sanitaryPipes',
    value: 'Sanitary Pipes',
    title: 'Sanitary Pipes',
    type: 'sanitary',
  },
  // double check correctness
  {
    layerPickerId: 'soils',
    value: 'Soil Classification',
    title: 'Soil Classification',
    type: 'general',
  },
  {
    layerPickerId: 'stormPoints',
    value: 'Storm Points',
    title: 'Storm Points',
    type: 'storm',
  },
  {
    layerPickerId: 'stormPipes',
    value: 'Storm Pipes',
    title: 'Storm Pipes',
    type: 'storm',
  },
  {
    layerPickerId: 'waterPoints',
    value: 'Water Points',
    title: 'Water Points',
    type: 'water',
  },

  {
    layerPickerId: 'waterMain',
    value: 'Water Main',
    title: 'Water Main',
    type: 'water',
  },

  {
    layerPickerId: 'waterTransmission',
    value: 'Water Transmission',
    title: 'Water Transmission',
    type: 'water',
  },

  {
    layerPickerId: 'waterService',
    value: 'Water Service',
    title: 'Water Service',
    type: 'water',
  },
  {
    layerPickerId: 'recycledWaterPipes',
    value: 'Recycled_Pipes',
    title: 'Recycled Water Lines',
    type: 'water',
  },
  {
    layerPickerId: 'recycledWaterPoints',
    value: 'Recycled_Points',
    title: 'Recycled Water Points',
    type: 'water',
  },
  // cant find this
  { value: 'Wells', title: 'Wells', type: 'general' },

  {
    layerPickerId: 'landUseCurbData',
    value: 'Curb',
    title: 'Curbs (San Francisco)',
    type: 'general',
  },
  {
    layerPickerId: 'fiberLitBuildings',
    value: 'Fiber Lit Buildings',
    title: 'Fiber Lit Buildings',
    type: 'telco',
  },
  {
    layerPickerId: 'cellTowers',
    value: 'Cell Towers',
    title: 'Cell Towers',
    type: 'telco',
  },
  {
    layerPickerId: 'submarineLandings',
    value: 'Submarine Landings',
    title: 'Submarine Landings',
    type: 'telco',
  },
  {
    layerPickerId: 'fiberRoutes',
    value: 'Fiber Routes',
    title: 'Fiber Routes',
    type: 'telco',
  },
  // DOUBLE CHECK
  {
    layerPickerId: 'submarineCables',
    value: 'Submarine Routes',
    title: 'Submarine Routes',
    type: 'telco',
  },
];

export const fileFormats = [
  {
    label: 'AutoCAD DWG',
    value: 'Autodesk AutoCAD - DWG_R14 - .dwg',
    short: 'dwg',
  },
  {
    label: 'Bentley MicroStation DGN',
    value: 'Bentley Microstation Design (V8) - DGN_V8 - .dgn',
    short: 'dgn',
  },
  { label: 'ESRI Shapefile', value: 'Shapefile - SHP - .shp', short: 'shp' },
  {
    label: 'Google Earth KMZ',
    value: 'OpenGIS KML Encoding Standard - OGCKML - .kmz',
    short: 'kmz',
  },
];

export enum UtilitiesPresent {
  Present = 'present',
  PresentAgencyConfirmed = 'present agency confirmed',
  NotPresent = 'not present',
  Digitized = 'digitized',
  AgencyNotSharing = 'agency not sharing',
  AgencyUnresponsive = 'agency unresponsive',
  OtherAgency = 'other agency',
  Other = 'other',
}

export enum RequestStatus {
  Request = 'request',
  Pending = 'pending',
  Requested = 'requested',
  ActionRequired = 'actionRequired',
  Complete = 'complete',
  Cancelled = 'cancelled',
  Dismissed = 'dismissed',
}

export const requestStatusMap: { [key: string]: string } = {
  [RequestStatus.Request]: 'Not Started',
  [RequestStatus.Pending]: 'In Queue',
  [RequestStatus.Requested]: 'In Progress',
  [RequestStatus.ActionRequired]: 'Action Required',
  [RequestStatus.Complete]: 'Completed',
  [RequestStatus.Cancelled]: 'Cancelled',
  [RequestStatus.Dismissed]: 'Dismissed',
};

export const assetsPresentMap: { [key: string]: string } = {
  [UtilitiesPresent.Present]: 'Present - Maps Received',
  [UtilitiesPresent.PresentAgencyConfirmed]: 'Present - Agency Confirmed',
  [UtilitiesPresent.NotPresent]: 'Not Present - Agency Confirmed',
  [UtilitiesPresent.Digitized]: 'Digitized',
  [UtilitiesPresent.AgencyNotSharing]: 'Unknown - Agency Policy to Not Share',
  [UtilitiesPresent.AgencyUnresponsive]: 'Unknown - Agency Unresponsive',
  [UtilitiesPresent.OtherAgency]: 'Other Agency - See Notes',
  [UtilitiesPresent.Other]: 'Other - See Notes',
};

export const statusColor: Record<RequestStatus, BadgeColor> = {
  [RequestStatus.Request]: 'orange',
  [RequestStatus.Pending]: 'blue',
  [RequestStatus.Requested]: 'blue',
  [RequestStatus.ActionRequired]: 'red',
  [RequestStatus.Complete]: 'green',
  [RequestStatus.Cancelled]: 'grey',
  // dismissed requests can be re-requested, so they display as a new request.
  [RequestStatus.Dismissed]: 'orange',
};
